import React, { useState, useEffect, useContext } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import './index.css'
import Loading from '../LoadingComponent'
import { Button, TextField, InputAdornment, IconButton,  List, ListItem, ListItemText, makeStyles, Divider } from '@material-ui/core'
import { FileCopy, Save, Print } from '@material-ui/icons'
import { isMobile } from 'react-device-detect'
import { jsPDF } from "jspdf"
import { saveAs } from 'file-saver'
import { ReactComponent as Close } from '../../assets/close.svg'



import {

	FacebookShareButton,
	InstapaperShareButton,
	LinkedinShareButton,
	TelegramShareButton,
	TwitterShareButton,
	ViberShareButton,
	WhatsappShareButton,
  } from "react-share";

  import {
	FacebookIcon,
	InstapaperIcon,
	LinkedinIcon,
	TelegramIcon,
	TwitterIcon,
	ViberIcon,
	WhatsappIcon,
  } from "react-share";
 
 
const useStyles = makeStyles((theme) => ({
	searchInput: {
	 
   },
   input: {
		background: '#F2F2F2',
		borderRadius: '2rem',
	   	margin: '1rem',
   },
   inputMobile: {
		background: '#F2F2F2',
		borderRadius: '2rem',
	   	margin: '1rem',
		paddingLeft: '0.3rem',
   },
   inputPlaceholder: {
	'&::placeholder': {
		fontStyle: 'italic',
		fontWeight: '600',
	  }
   },
   inputPlaceholderMobile: {
	'&::placeholder': {
		fontStyle: 'italic',
		fontSize: '0.9rem',
		fontWeight: '600',
	  }
   },
	btn:{ 
		marginLeft: '1rem',	 
	}
}));
 
const SocialShare = ({ cid, qrURL, qrImage }) => {

  	const [ saveString, setSaveString ] = useState('')
	const [ isDisabled, setIsDisabled ] = useState(true)
	const [ copySuccess, setCopySuccess ] = useState('')
	const [ isLoading, setIsLoading ] = useState(true)
  	const { resetPN, setPageNumber, signOut } = useContext(AuthContext)
	const params = useParams()
	const navigate = useNavigate()
  	const classes = useStyles()

  	useEffect(()=>{
			if(saveString!==''){
					setIsDisabled(false)
			}else{
					setIsDisabled(true)
			}
  	},[saveString])

	const handlePDFSave = () => {
			const doc = new jsPDF();
			doc.text("qr-code", 10, 10);
			doc.addImage(qrImage, 'PNG', 10, 30, 150, 150);
	  		doc.save(saveString + ".pdf");
	}

  	const handleSave = () => {
			saveAs(qrImage, "qr-code.png")
  	}

	const handleCopy = () => {
			navigator.clipboard.writeText(qrURL)
			setCopySuccess('Copyed')
			setTimeout(() => {setCopySuccess('')}, 3000)
	}

	const handlePrint = () => {
			var win = window.open('')
			win.document.write('<img src="' + qrURL + '" onload="window.print();window.close()" />')
  			win.focus()	
	}

	useEffect(() => {
		setTimeout(() => setIsLoading(false), 1000) 
		window.addEventListener('popstate', onBackButtonEvent)
	 
		return () => {
			  window.removeEventListener('popstate', onBackButtonEvent);
		}
	}, [])

  	const onBackButtonEvent = (e) => {
			e.preventDefault()
			setPageNumber(null)
			setTimeout(() => {
				navigate(`/kekspos/${params.tid}`)
			},0) 	 
  	}

	useEffect(() => 
	{   
		const handleReload = async (e) => 
		{
			e.preventDefault()
			signOut(cid)
			setTimeout(() => window.location.assign(`/kekspos`, 0));
  
			window.removeEventListener('beforeunload', handleReload) 
					
			return false
		}
  
		window.addEventListener("beforeunload", handleReload)
		   
		return () => 
		{    
			window.removeEventListener('beforeunload', handleReload) 
		}
	
	}, [])

if(!isLoading){
  	return (
    	<div className="share">
			<div className="share-header">
				<TextField 	variant="outlined"
						className={classes.searchInput}
						style={{ width:!isMobile?'25rem':'90%'}}
						placeholder="Upiši ime pdf datoteke"
						InputProps = {{
								className: !isMobile?classes.input:classes.inputMobile,
								classes: { input: !isMobile?classes.inputPlaceholder:classes.inputPlaceholderMobile},
							 	startAdornment: (
										<InputAdornment position="start">
											<IconButton disabled={isDisabled} onClick={() => handlePDFSave()}> 
												<Save />
											</IconButton>
								 		</InputAdornment>
							 	)
						}}
						value={saveString}
						onChange = {(event)=>event.target.value.length<16?setSaveString(event.target.value):null}	  
				/>
	  			<Button variant="contained"
						size="small"
						style={{	height:'3rem',
									marginTop:'1.2rem',
									marginRight:'0.6rem',
									borderRadius:'3rem',
									textDecoration:'none'
						}}
						component={Link}
						to={`/kekspos/${params.tid}`}
						onClick={()=>resetPN()}
				><Close /></Button>
			</div>
			<Divider />
			<div style={{display:'flex', justifyContent:'center'}}>
				<div className="social-btns" style={{width:!isMobile?'35rem':'20rem'}}>
					<TelegramShareButton url={qrURL} className={classes.btn1}>
						<TelegramIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</TelegramShareButton>
					<ViberShareButton url={qrURL} className={classes.btn}>
						<ViberIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</ViberShareButton>
					<WhatsappShareButton url={qrURL} className={classes.btn}>
						<WhatsappIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</WhatsappShareButton>
					<FacebookShareButton url={qrURL} className={classes.btn}>
  						<FacebookIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</FacebookShareButton>
					<TwitterShareButton url={qrURL} className={classes.btn}>
  						<TwitterIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</TwitterShareButton>
					<InstapaperShareButton url={qrURL} className={classes.btn}>
						<InstapaperIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</InstapaperShareButton>
					<LinkedinShareButton url={qrURL} className={classes.btn}>
  						<LinkedinIcon url={qrURL} style={{borderRadius:'1rem'}}/>
					</LinkedinShareButton>
				</div>
			</div>
		
			<div style={{ display:'flex', flexDirection:'column',justifyContent:'center', alignItems:'center'}}>
				<List component="nav" style={{padding:0, width:!isMobile?'25rem':'90%', backgroundColor:'#fff', borderRadius:'1rem', marginBottom:'1rem'}}>
					<ListItem button  onClick={() => handleCopy()}>
  		        		<ListItemText primary="Copy" />
						<div style={{paddingRight:'2rem', color:'red'}}>{copySuccess}</div>
    					<FileCopy />
  					</ListItem>
				</List>
				<List component="nav" style={{padding:0, width:!isMobile?'25rem':'90%', backgroundColor:'#fff', borderRadius:'1rem'}}>
  		 			<ListItem button  onClick={() => handleSave()}>
  		        		<ListItemText primary="Save Image" />
						<Save />
  					</ListItem>
		 			<Divider style={{width:'100%'}}/>
  					{/* <ListItem button  >
  		    			<ListItemText primary="Assign to Contact" />
						<Contacts />
  					</ListItem> */}
					<Divider style={{width:'100%'}}/>
					<ListItem button onClick={()=>handlePrint()}  >
  		    				<ListItemText primary="Print" />
							<Print />
  					</ListItem> 
					{/*<Divider style={{width:'100%'}}/>
  					 <ListItem button  >
  		        		<ListItemText primary="Edit with focos" />
						<Edit />
  					</ListItem>
					<Divider style={{width:'100%'}}/>
  					<ListItem button   >
  		      			<ListItemText primary="Add to share album" />
						<Share />
  					</ListItem>
					<Divider style={{width:'100%'}}/>
  					<ListItem button  >
  		        		<ListItemText primary="Create watch face" />
						<Watch />
  					</ListItem>
					<Divider style={{width:'100%'}}/> 
					<ListItem button  >
  		        		<ListItemText primary="Save to files" />
						<Folder />
  					</ListItem>*/}
				</List>
			</div>
    	</div>
  )
}else{
    return(
      <div>
          <Loading/>
      </div>
    )
}
}

export default SocialShare
